export function navigateToTeamSettings() {
  window.location = 'https://dashboard.clearbit.com/team';
  return;
}

export function navigateToProfileSettings() {
  window.location = 'https://dashboard.clearbit.com/profile';
  return;
}
